export default __webpack_public_path__ + "static/croc@2x-11db3b3a9e4078c3d4c4c843ce1e4b65.png";